import { createSlice } from '@reduxjs/toolkit';
import initialState from '../department/department.initialState';
import { fetchDepartments } from '../department/department.actions';

export const departmentSlice = createSlice({
  name: 'departmentSlice',
  initialState: initialState,
  extraReducers: (builder) => {
    builder
      .addCase(fetchDepartments.pending, (state) => {
        state.departments.loading = true;
        state.departments.error = null;
      })
      .addCase(fetchDepartments.rejected, (state, action) => {
        state.departments.loading = false;
        state.departments.error = action.payload;
      })
      .addCase(fetchDepartments.fulfilled, (state, action) => {
        state.departments.data = action.payload;
        state.departments.loading = false;
        state.departments.error = null;
      });
  },
});
